import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtText from "../../../components/NtText";
import { useMobile } from "../../../hooks/useMobile";

function NtBusinessBenefitSection(props) {
  const isMobile = useMobile();
  const renderBox = (containerStyle, icon, title, subtitle) => {
    return (
      <View
        style={[
          {
            flex: 1,
            borderRadius: 10,
            backgroundColor: "#181818",
            alignItems: "center",
            padding: 20,
          },
          containerStyle,
        ]}
      >
        <NtMaterialIcon name={icon} size={35} color="#12ABFF" />

        <NtText
          style={{
            marginTop: 15,
            color: "white",
            fontSize: 16,
            fontWeight: "800",
          }}
        >
          {title}
        </NtText>
        <NtText
          style={{
            marginTop: 8,
            color: "white",
            fontSize: 11,
            fontWeight: "300",
            textAlign: "center",
          }}
        >
          {subtitle}
        </NtText>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <NtSectionTitle>BENEFITS</NtSectionTitle>
      <NtSectionDescription style={{ marginTop: 8, textAlign: "center" }}>
        Flexible, affordable business phone solutions with global access, zero
        contracts, no IT hassles, and no hidden fees.
      </NtSectionDescription>

      <View
        style={{ flexDirection: isMobile ? "column" : "row", marginTop: 40 }}
      >
        {renderBox(
          { marginRight: isMobile ? 0 : 10, marginBottom: isMobile ? 10 : 0 },
          "globe-model",
          "Live Global, Look Local",
          "Team members worldwide, connecting locally with US or Canada numbers."
        )}

        {renderBox(
          { marginRight: isMobile ? 0 : 10, marginBottom: isMobile ? 10 : 0 },
          "currency-usd",
          "Great Features. Low Cost.",
          "Enjoy big business features at small business prices."
        )}

        {renderBox(
          {},
          "cloud-print-outline",
          "No IT? No Problem.",
          "DIY configuration with online support. No IT professional required."
        )}
      </View>

      <View
        style={{ flexDirection: isMobile ? "column" : "row", marginTop: 10 }}
      >
        {renderBox(
          { marginRight: isMobile ? 0 : 10, marginBottom: isMobile ? 10 : 0 },
          "office-building",
          "No Office? No Problem",
          "Take your business phone with you using the PBX App."
        )}

        {renderBox(
          { marginRight: isMobile ? 0 : 10, marginBottom: isMobile ? 10 : 0 },
          "receipt",
          "No Activation Fees",
          "Enjoy savings from day one."
        )}

        {renderBox(
          {},
          "file-remove-outline",
          "No Contracts",
          "Tired of being tied down? Go contract-free with NexGen Business."
        )}
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtBusinessBenefitSection;
